// extracted by css-extract-rspack-plugin
export default {"margins":"ButtonsPage-margins_b9S"};